module.exports = __webpack_public_path__ + "static/media/search-location.03c5b28f.svg";